import script from "./StopList.vue?vue&type=script&setup=true&lang=js"
export * from "./StopList.vue?vue&type=script&setup=true&lang=js"

import "./StopList.vue?vue&type=style&index=0&id=837fb60e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-837fb60e"]])

export default __exports__